import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);

        this.animContent = [
            {
                selector: '.o-flexible-content h1, .o-flexible-content .o-display-1',
                class: 'u-anim-opacity-up',
                data: 'data-scroll data-scroll-offset="10%"',
                // module: 'SplitLines',
            },
            {
                selector: '.o-flexible-content .o-text .o-subtitle, .o-flexible-content .o-text p:not(.c-accordion p), .o-flexible-content .o-text h2:not(.o-display-1), .o-flexible-content .o-text h3, .o-flexible-content .o-text h4, .o-flexible-content .o-text h5, .o-flexible-content .o-text h6, .o-text ul, .o-text ol',
                class: 'u-anim-opacity-up',
                data: 'data-scroll data-scroll-offset="10%"',
                module: '',
            },
            {
                selector: '.o-flexible-content .o-button-group',
                class: 'u-anim-opacity-up',
                data: 'data-scroll',
                module: '',
            },
            {
                selector: '.o-flexible-content .o-text figure.table',
                class: 'u-anim-opacity-up',
                data: 'data-scroll',
                module: '',
            }
        ];
    }

    init() {
        function onScroll({ direction, scroll }) {
            if (scroll < 100) {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.remove('lenis-scrolling-down');
            } else if (direction === -1) {
                document.querySelector('html').classList.add('lenis-scrolling-up');
                document.querySelector('html').classList.remove('lenis-scrolling-down');
            } else if (direction === 1) {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.add('lenis-scrolling-down');
            } else {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.add('lenis-scrolling-down');
            }
        }

        this.animContent.forEach((anim) => {
            const elements = document.querySelectorAll(anim.selector);
            elements.forEach((el) => {
                if (anim.class) {
                    el.classList.add(anim.class);
                }
                if (anim.data) {
                    const data = anim.data.split(' ');
                    data.forEach((item) => {
                        const [key, value] = item.split('=');
                        if (value) {
                            el.setAttribute(key, value.replace(/"/g, ''));
                        } else {
                            el.setAttribute(key, '');
                        }
                    });
                }
                if (anim.module === 'SplitLines') {
                    el.setAttribute('data-module', anim.module);
                    el.setAttribute('data-line-delay', '0');
                    el.setAttribute('data-line-stagger', '0.15');
                    this.call('update', el.parentElement, 'app');
                }
            });
        });

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

        window.addEventListener('footerIsVisible', (e) => {
            const { target, way, from } = e.detail;
            if (way === 'enter') {
                document.querySelector('html').classList.add('footer-is-visible');
            } else if (way === 'leave') {
                document.querySelector('html').classList.remove('footer-is-visible');
            } else {
                document.querySelector('html').classList.remove('footer-is-visible');
            }
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });

        document.querySelector('html').classList.add('is-scroll-initialized');
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        window.removeEventListener('progressEvent', this.handleProgressEvent);
        document.querySelector('html').classList.remove('is-scroll-initialized');
    }
}
